/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  Object Strucutre:
                    path => router path
                    name => router name
                    component(lazy loading) => component to load
                    meta : {
                      rule => which user can have access (ACL)
                      breadcrumb => Add breadcrumb to specific page
                      pageTitle => Display title besides breadcrumb
                    }
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";
import store from "@/store/store";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "",
      component: () => import("./layouts/main/Main.vue"),
      children: [
        {
          path: "/",
          name: "home",
          component: () => import("./views/Home.vue"),
          meta: {
            rule: "isUser",
          },
        },
        {
          path: "/report",
          name: "report",
          component: () => import("./views/Report.vue"),
          meta: {
            rule: "isUser",
          },
        },
        {
          path: "/notification",
          name: "notification",
          component: () => import("./views/Notification.vue"),
          meta: {
            rule: "isUser",
          },
        },
        {
          path: "/users",
          name: "users",
          component: () => import("./views/users/Users.vue"),
          meta: {
            rule: "isAdmin",
          },
        },
        {
          path: "/edit-users",
          name: "edit-users",
          component: () => import("./views/users/EditUser.vue"),
          meta: {
            rule: "isAdmin",
          },
        },
        {
          path: "/profile",
          name: "profile",
          component: () => import("./views/Profile.vue"),
          meta: {
            rule: "isUser",
          },
        },
        {
          path: "/test",
          name: "test",
          component: () => import("./views/Page2.vue"),
          meta: {
            rule: "isUser",
          },
        },
        
        {
          path: "/edit-profile",
          name: "edit-profile",
          component: () => import("./views/EditProfile.vue"),
          meta: {
            rule: "isUser",
          },
        },
        {
          path: "/Domestic",
          name: "Domestic",
          component: () => import("./views/Domestic.vue"),
          meta: {
            rule: "isUser",
          },
        },
        {
          path: "/Export",
          name: "Export",
          component: () => import("./views/Export.vue"),
          meta: {
            rule: "isUser",
          },
        },
        {
          path: "/create-user",
          name: "createUser",
          component: () => import("./views/users/CreateUser.vue"),
          meta: {
            rule: "isAdmin",
          },
        },
        {
          path: "/oil-price-log",
          name: "oilPriceLog",
          component: () => import("./views/OilPriceLog.vue"),
          meta: {
            rule: "isAdmin",
          },
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/pages/login",
          name: "pageLogin",
          component: () => import("@/views/pages/Login.vue"),
          meta: {
            rule: "isPublic",
          },
        },
        
        {
          path: "/pages/error-404",
          name: "pageError404",
          component: () => import("@/views/pages/Error404.vue"),
        },
        {
          path: "/pages/register",
          name: "register",
          component: () => import("./views/pages/Register.vue"),
        },
        {
          path: "/pages/ForgetPass",
          name: "Forget",
          component: () => import("./views/pages/ForgotPassword.vue"),
        },
        {
          path: "/pages/ResetPass",
          name: "Reset",
          component: () => import("./views/pages/ResetPassword.vue"),
        },
        {
          path: "/report/DetailReportTransit",
          name: "DetailReportTransit",
          component: () => import("./views/DetailReportTransit.vue"),
          meta: {
            rule: "isUser",
          },
        },
        {
          path: "/report/DetailReport",
          name: "DetailReportDmtEp",
          component: () => import("./views/DetailReportDmtEp.vue"),
          meta: {
            rule: "isUser",
          },
        },
        {
          path: "/printNotification",
          name: "printNotification",
          component: () => import("./views/PrintNotification.vue"),
          meta: {
            rule: "isUser",
          },
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404",
    },
  ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

router.beforeEach((to, from, next) => {
  if (
    to.path === "pages/register" ||
    to.path === "/pages/login" ||
    to.path === "/pages/forgot-password" ||
    to.path === "/pages/error-404" ||
    to.path === "/pages/error-500" ||
    to.path === "/pages/register" ||
    to.path === "/callback" ||
    to.path === "/pages/comingsoon" ||
    store.state.auth.isLoginSuccess
  ) {
    return next();
  }
  // TODO: login
  return next();
  // router.push({ path: "/pages/login", query: { to: to.path } });
});

export default router;
